import React from 'react';
import { Box, Card, CardContent, CardHeader, Checkbox, Divider, FormControlLabel } from '@material-ui/core';
import { useFormikContext } from 'formik';
import { ISettingsGroups } from '../interfaces';

interface IProps {
  disabled?: boolean;
}

const PartnersSettings = ({ disabled }: IProps) => {
  const { values, setFieldValue } = useFormikContext<{ settings: ISettingsGroups }>();

  const {
    groupName,
    settings: [BAD_PARTNER_BLOCK],
  } = values.settings[0];

  const field = (index: number) => `settings[0].settings[${index}].value`;

  return (
    <Card>
      <CardHeader title={groupName} />
      <Divider />

      <CardContent component={Box} sx={{ display: 'flex', flexDirection: 'column', gridGap: 16 }}>
        <FormControlLabel
          disabled={disabled}
          control={
            <Checkbox
              color="primary"
              checked={BAD_PARTNER_BLOCK.value}
              onChange={(e) => setFieldValue(field(0), e.target.checked)}
            />
          }
          label={BAD_PARTNER_BLOCK.description}
        />
      </CardContent>
    </Card>
  );
};

export default PartnersSettings;
